import { Component, OnInit } from '@angular/core';
import { ViewCell, Cell, DefaultEditor, Editor } from 'ng2-smart-table';
@Component({
  selector: 'ngx-item-cell-editor',
  templateUrl: './item-cell-editor.component.html',
  styleUrls: ['./item-cell-editor.component.scss']
})
export class ItemCellEditorComponent extends DefaultEditor implements OnInit {

  listaOpciones: any[];
  selectedItem: any;
  constructor(){

    super();
  }

  ngOnInit(): void {
    this.selectedItem = this.cell.getValue().identifier

  }

  updateItemElement(event){
      this.cell.newValue = this.listaOpciones.find( i => i.identifier == this.selectedItem);
  }
}
